import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiService } from '../../../api.service';
import { HelperService } from '../../../utils/helper.service';

import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import memoizeObservable from '../../../utils/memoize-observable';
import { LocalStorageSettingsService } from './local-storage-settings-service.service';
import { ReportsList } from '../models/reports-list';
import { ReportMappingService } from './report-mapping.service';
import { DataObject, ReportFilterFormControl, ReportsFilterObj } from '../../../interfaces/data-objects';


@Injectable({
  providedIn: 'root',
})
export class ReportingFilteringService {
  clearDateRange: Subject<boolean> = new Subject();
  localfilters: ReportsFilterObj;
  reportFilterFormControls: ReportFilterFormControl[];

  getFilterFormControls(report: DataObject): ReportFilterFormControl[] {
    this.reportFilterFormControls = [];
    if (report.transaction_types_list) {
      this.reportFilterFormControls.push({
        id: 'transaction_types_list',
        label: 'Transaction Type',
        name: 'all_transactions',
        list: report.transaction_types_list,
        selectedValues: this.localfilters.transaction_types_list,
        isSearch: true,
        isMultiSelect: true
      });
    }
    if (report.functional_unit_list) {
      this.reportFilterFormControls.push({
        id: 'functional_unit_list',
        label: 'Functional Unit',
        name: 'all_functionals',
        list: report.functional_unit_list,
        selectedValues: this.localfilters.functional_unit_list,
        isSearch: true,
        isMultiSelect: true
      });
    }
    if(report.managing_office_list) {
      this.reportFilterFormControls.push({
        id: 'managing_office_list',
        label: 'Managing Office',
        name: 'all_managings',
        list: report.managing_office_list,
        selectedValues: this.localfilters.managing_office_list,
        isSearch: true,
        isMultiSelect: true
      });
    }
    if (report.producer_list) {
      this.reportFilterFormControls.push({
        id: 'producer_list',
        label: 'Producer',
        name: 'all_producers',
        list:  report.producer_list,
        selectedValues: this.localfilters.producer_list,
        isSearch: true,
        isMultiSelect: true
      });
    }
    return this.reportFilterFormControls;
  }

  getReportsPageModel = memoizeObservable(() => {
    return this.api.get(`/api/reports/`);
  });

  getFilterFormControlsData$ = memoizeObservable((report_id: number) => {
    return this.api.get(`/api/reports/report_filters/${report_id}/`)
      .pipe(
        map((report: any) => this.getFilterFormControls(report))
      );
  });

  constructor(
    private api: ApiService,
    private localstoragesettings: LocalStorageSettingsService,
    private reportmapping: ReportMappingService,
    private helperService: HelperService
  ) {
    this.localfilters = this.localstoragesettings.getLocalFilters();
  }

  clearDateRangeFilter(isClear: boolean): void {
    this.clearDateRange.next(isClear);
  }

  downloadExcelReport(reportId: number, queryParams: string) {
    const { transaction_types_list, functional_unit_list, managing_office_list } = this.reportmapping.getFiltersAsParams();

    const filterParams = new HttpParams()
      .set('transaction_types_list', transaction_types_list)
      .set('functional_unit_list', functional_unit_list)
      .set('managing_office_list', managing_office_list)
      .set('download', true);

    const reportingDownloadService = `/api/reports/report_details/${reportId}/${queryParams}`;

    return this.api.get(reportingDownloadService, { params: filterParams })
      .pipe(map(response => {
        if (+reportId === ReportsList.LEASE_PROPERTY_CUSTOMER_DATA) {
          this.reportmapping.mapPropertyDetails(response);
          this.reportmapping.mapSpaceTypeDetails(response);
          this.reportmapping.mapBillToCustomer(response);
        }
        return response;
      })
    );
  }
}
